import React from "react";

const PrintTestComponent = () => {
    const handlePrint = () => {
        window.print();
      };
    
      return (
        <div>
          <h1>Contenido para imprimir</h1>
          <p>Este contenido se imprimirá cuando hagas clic en el botón.</p>
          <button onClick={handlePrint}>Imprimir</button>
        </div>
      );
    };



export default PrintTestComponent;
